import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuelidate from 'vuelidate'

import './styles/quasar.styl'
//import 'quasar-framework/dist/quasar.ie.polyfills'
//import 'quasar-extras/animate'
//import 'quasar-extras/roboto-font'
import 'quasar-extras/material-icons'
//import 'quasar-extras/fontawesome'
//import 'quasar-extras/ionicons'
//import 'quasar-extras/mdi'
import Quasar, * as All from 'quasar'

import moment from 'moment'
Vue.prototype.moment = moment

Vue.use(Vuelidate)

//-------------Quasar localistation --- set to German------------------
var lang = 'de'
import(`quasar-framework/i18n/${lang}`).then(lang => {
  Quasar.i18n.set(lang.default)
})
//-------------WTracking Localisation----------------------------------

import VueI18n from 'vue-i18n'
import globalText from "@/assets/globalText.js"
import './registerServiceWorker'
const messages = globalText
Vue.use(VueI18n)

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'de', // set locale
  messages // set locale messages
})

Vue.use(Quasar,
{
  components: All,
  directives: All,
  plugins: All
})
//Set Organisation
var org = 1 // 0 = Developpment, 1 = Insafety, 2 = Dev via Caddy Proxy for ssl testing, not working...
if(org == 0){
  //to test camera: http://127.0.0.1:8080/
  //Vue.prototype.$apiUrl = 'http://192.168.0.155/WTrackingAPI/api/ClientApi'
  //Vue.prototype.$reportUrl = 'http://192.168.0.155/WTrackingAPI/report'
  Vue.prototype.$apiUrl = 'http://swisstopo.insafety.ch/WTrackingAPI/api/ClientApi'
  Vue.prototype.$apiGoUrl = 'http://swisstopo.insafety.ch:9002'
  Vue.prototype.$reportUrl = 'http://swisstopo.insafety.ch/WTrackingAPI/report'
  Vue.prototype.$tilesUrl = 'http://swisstopo.insafety.ch/WTrackingAPI/tiles'
}
if(org == 1){
  Vue.prototype.$apiUrl = 'https://wtrackingapi.insafety.ch/api/ClientApi'
  Vue.prototype.$reportUrl = 'https://wtrackingapi.insafety.ch/report'
  Vue.prototype.$apiGoUrl = 'https://wtrackingapi.insafety.ch:9002'
  Vue.prototype.$tilesUrl = 'https://wtrackingapi.insafety.ch/tiles'
}
if(org == 2){
  //Vue.prototype.$apiUrl = 'https://dev.timeprojects.com/WTrackingAPI/api/ClientApi'
  Vue.prototype.$apiUrl = 'http://swisstopo.insafety.ch/WTrackingAPI/api/ClientApi'
  Vue.prototype.$apiGoUrl = 'http://swisstopo.insafety.ch:9002'
  Vue.prototype.$reportUrl = 'https://dev.timeprojects.com/WTrackingAPI/report'
  Vue.prototype.$tilesUrl = 'https://dev.timeprojects.com/WTrackingAPI/tiles'
}

Vue.prototype.$copyRight = '2023 Insafety GmbH, Zürich, Switzerland'
Vue.prototype.$org = org
Vue.config.productionTip = false

export const eventBus = new Vue()  //set up our global eventBus BEFORE the main vue instance

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

